module.exports = __webpack_public_path__ + "media/images/buttons/button-scroll-top-30b21e963a0f8bc15556ebb0882fb1ed.svg";